import http from 'hub-http/clients/apiClient';
import { oldKeys } from '../records/ArticleRecord';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/knowledge-content/v1/knowledge-articles';
const ALLOWED_TRANSLATED_CONTENT_PROPERTIES = ['translatedContent.*.id', 'translatedContent.*.language', 'translatedContent.*.name', 'translatedContent.*.state'];
const ALLOWED_ARTICLE_RECORD_PROPERTIES = [...oldKeys].concat(ALLOWED_TRANSLATED_CONTENT_PROPERTIES);
export default class ArticleEditInfoApi {}
ArticleEditInfoApi.get = makeSimpleQuickFetchWrapper(articleId => `get-article-edit-info-${articleId}`, articleId => http.get(`${API_BASE}/${articleId}/edit-info`, {
  query: {
    property: ALLOWED_ARTICLE_RECORD_PROPERTIES
  }
}));